
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { CenteredSpinnerWrapper, Spinner } from '@Components/common/Spinner';
import DeliveryServiceCard from '@Components/DeliveryService';
import GuaranteeCard from '@Components/GuaranteeCard';
import ProductDescriptionSection from '@Components/InnerProduct/ProductDescriptionSection';
import ProductDetailsSection from '@Components/InnerProduct/ProductDetailsSection';
import ProductReviewsSection from '@Components/InnerProduct/ProductReviewsSection';
import RelatedProductsSection from '@Components/InnerProduct/RelatedProductsSection';
import Layout from '@Components/Layout';
import { useAuth } from '@Contexts/AuthContext/Auth.context';
import { _GetProductDetails, _GetProductRate, _GetProductReviews, _GetProducts } from '@Services/Products';
import { K_AllProducts, K_ProductDetails, K_ProductRate, K_ProductReview } from '@Utils/ReactQuery.keys';
import { AxiosError } from 'axios';
import ReactQueryConfig from 'lib/ReactQueryConfig';
import { GetStaticPathsContext, GetStaticPropsContext, NextPage } from 'next';
import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import React, { Fragment, useMemo, useState } from 'react';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import { APIResponse } from 'types/APIResponse';
import { Product } from 'types/Products';

interface IParams extends ParsedUrlQuery {
  id: string;
}

type Props = {};
const InnerProduct: NextPage<Props> = () => {
  const router = useRouter();
  const query = router.query as IParams;
  const { isTokenValid } = useAuth();
  const { data } = useQuery(
    K_ProductDetails({
      product_id: query.id,
      locale: router.locale,
    }),
    () => _GetProductDetails(query.id)
  );
  const { data: reviewData } = useQuery(
    K_ProductReview({
      locale: router.locale,
      product_id: query.id,
    }),
    () =>
      _GetProductReviews({
        product_id: query.id as string,
      }),
    { enabled: isTokenValid }
  );

  const { data: rateData } = useQuery(
    K_ProductRate({
      product_id: query.id as string,
      locale: router.locale,
    }),
    () => _GetProductRate(query.id as string),
    { enabled: isTokenValid }
  );

  const [offset, setOffset] = useState(0);
  const specialProductsKeys = useMemo(
    () => ({
      limit: 4,
      offset,
      category_id: data?.id,
    }),
    [data?.id, offset]
  );
  const { data: relatedProducts, isLoading: relatedProductsLoading } = useQuery(
    K_AllProducts({ ...specialProductsKeys, locale: router.locale }),
    () => _GetProducts(specialProductsKeys),
    {
      onSuccess: (data) => {
        setTotalProducts(data.count);
      },
    }
  );
  const [totalProducts, setTotalProducts] = useState(relatedProducts?.count);

  return (
    <Layout seoData={{ title: (data as Product)?.name || '...' }}>
      <Container>
        <Row>
          <Col col={12} md={9}>
            {data ? (
              <Fragment>
                <ProductDetailsSection data={data} rateData={rateData} reviewData={reviewData} />
                <ProductDescriptionSection data={data} />
                {rateData && reviewData && <ProductReviewsSection reviewData={reviewData} rateData={rateData} />}
              </Fragment>
            ) : (
              <CenteredSpinnerWrapper>
                <Spinner />
              </CenteredSpinnerWrapper>
            )}
          </Col>
          <Col col={12} md={3}>
            <GuaranteeCard />
            {/* <OfferCard /> */}
            <DeliveryServiceCard />
          </Col>
        </Row>
      </Container>
      {Boolean(totalProducts) && (
        <RelatedProductsSection
          products={relatedProducts as APIResponse<Product[]>}
          isLoading={relatedProductsLoading}
          setOffset={setOffset}
          totalProducts={totalProducts as number}
        />
      )}
    </Layout>
  );
};

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
 async function _getStaticProps({ params, locale }: GetStaticPropsContext) {
  const { id } = params as IParams;
  try {
    const productData = await _GetProductDetails(id);
    const queryClient = new QueryClient(ReactQueryConfig);
    await queryClient.setQueryData(
      K_ProductDetails({
        product_id: id,
        locale: locale,
      }),
      productData
    );
    return {
      props: {
        dehydratedState: dehydrate(queryClient),
      },
      revalidate: 60, // In seconds
    };
  } catch (error) {
    const err = error as AxiosError;
    return {
      notFound: true,
      props: {
        statusCode: err.response?.status,
      },
    };
  }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
export async function getStaticPaths(ctx: GetStaticPathsContext) {
  const { results } = await _GetProducts({
    best_seller: true,
  });
  // Get the paths we want to pre-render based on posts
  const paths = results.map((product) => ({
    params: { id: product.id.toString() },
  }));

  // We'll pre-render only these paths at build time.
  // { fallback: blocking } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths, fallback: 'blocking' };
}

export default InnerProduct;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/[id]',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  